import * as React from 'react';
import { SearchResults } from '../model/searchresultModel';
import { v4 as uuidv4 } from "uuid";
import RecipePageStarRatingStatic from '../../RecipePage/StarRatingStatic';

interface RecipeSearchResultsModel {
    result: SearchResults,
}

const RecipeSearchResults: React.FC<RecipeSearchResultsModel> = (props) => {

    const preparationtime = (prep: string) => {
        switch (prep) {
            case 'lessthantwentyminutes':
                return 'Under 20 min'
                break;
            case 'twentytofortyminutes':
                return '20-40 min'
                break;
            case 'fortytosixtyminutes':
                return '40-60 min'
                break;
            case 'oversixtyminutes':
                return 'Over 60 min'
                break;
        }        
    }

    return (
        <ul className="grid grid-cols-2 laptop:grid-cols-3 gap-y-7 gap-x-5">
            {props.result.recipeSearchResult.pages.map((recipe) => {
                return (
                    <li key={uuidv4()} className="rounded-lg relative group focus-within:outline-[3px] focus-within:outline-red-secondary">
                        {recipe.media?.url !== '' && (
                            <figure className="overflow-hidden rounded-xl mb-3 aspect-[3/2] bg-orange-25 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWltYWdlLWljb24gbHVjaWRlLWltYWdlIj48cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjMiIHk9IjMiIHJ4PSIyIiByeT0iMiIvPjxjaXJjbGUgY3g9IjkiIGN5PSI5IiByPSIyIi8+PHBhdGggZD0ibTIxIDE1LTMuMDg2LTMuMDg2YTIgMiAwIDAgMC0yLjgyOCAwTDYgMjEiLz48L3N2Zz4=')] bg-center bg-no-repeat">
                                <picture>
                                    <source media="(min-width: 1280px)" srcSet={`${recipe.media.url}__w=269_h=180__autocrop=true`} />
                                    <source media="(min-width: 1024px)" srcSet={`${recipe.media.url}__w=205_h=137__autocrop=true`} />
                                    <source media="(min-width: 768px)" srcSet={`${recipe.media.url}__w=346_h=230__autocrop=true`} />
                                    <img loading="lazy" src={`${recipe.media.url}__w=735_h=490__autocrop=true`} alt={recipe.media.description} className="transition-all group-hover:scale-110 group-active:scale-105 w-full"/>
                                </picture>
                            </figure>
                        )}
                        <h3 className='font-semibold text-xl laptop:text-2xl leading-7 mb-1.5 laptop:leading-8 laptop:mb-2'>
                            {recipe.pageTitle}
                        </h3>
                        <div className='flex justify-start'>
                            <RecipePageStarRatingStatic contentId={recipe.id.toString()} />
                        </div>
                        <p className="flex gap-1 mt-1.5">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 6.80664V12.8066L16 14.8066M22 12.8066C22 18.3295 17.5228 22.8066 12 22.8066C6.47715 22.8066 2 18.3295 2 12.8066C2 7.28379 6.47715 2.80664 12 2.80664C17.5228 2.80664 22 7.28379 22 12.8066Z" stroke="#BE9164" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            {preparationtime(recipe.preparationTime.toLowerCase())}
                        </p>

                        <a href={recipe.url} title={recipe.pageTitle} className='absolute inset-0 focus-visible:outline-2 outline-offset-4 outline-red-secondary rounded-lg'>
                            <span className="sr-only">{recipe.pageTitle}</span>
                        </a>
                    </li>
                )
            })}
        </ul>
    );
};

export default RecipeSearchResults;


